import React from "react";
import { Link } from "react-router-dom";
import FadeInSection from "../FadeInSection";
import "./Mythology.css";

const artifacts = [
  {
    name: "narcissus and echo fresco",
    type: "Roman wall painting (4th Pompeian style)",
    date: "45–79 CE",
    location: "Museo Archeologico Nazionale di Napoli, Naples (inv. 9380)",
    origin: "Pompeii, VI.7.20, tablinum 7",
    img: "https://upload.wikimedia.org/wikipedia/commons/e/ee/Affresco_romano_-_Pompei_-_Narciso_ed_Eco.JPG",
    imgAlt: "Roman fresco depicting Narcissus gazing at his reflection, with Echo seated at left and Eros below",
    imgCredit: "Wikimedia Commons / public domain",
    analysis:
      "This fresco, excavated from Pompeii and now in Naples, depicts Narcissus seated at a still pool, gazing at his own reflection while a small Eros stands below. Echo sits apart at the left edge of the scene and watches him from a distance she cannot cross. The composition captures the myth's double punishment. Narcissus, who rejected every offer of love including Echo's, is condemned to love an image that cannot return his feeling. Echo, whose voice was already taken by Hera for covering Zeus's infidelities, can only watch; in Ovid her body later wastes away from the rejection until only sound remains. The stillness of the fresco is part of the punishment, with Narcissus fixed at the water and Echo fixed at the margin. In Overwatch, Echo's kit mirrors this pattern. Her ultimate is called Duplicate, and she is an entity built to copy others without a voice of her own.",
  },
  {
    name: "gorgoneion antefix",
    type: "Painted terracotta architectural element",
    date: "ca. 540 BCE",
    location: "Metropolitan Museum of Art, New York (acc. 39.11.9)",
    origin: "South Italian, Tarentine",
    img: "https://upload.wikimedia.org/wikipedia/commons/d/db/Terracotta_painted_gorgoneion_antefix_%28roof_tile%29_MET_DP233549.jpg",
    imgAlt: "Painted terracotta antefix showing a Gorgon face with wide eyes and snakes, ca. 540 BCE",
    imgCredit: "Metropolitan Museum of Art / CC0 public domain",
    analysis:
      "Antefixes were terracotta tiles placed at the eaves of Greek temples to conceal and protect the ends of roof tiles. This example from Taranto shows Medusa in her post-transformation state: wide-staring eyes, a grimacing mouth, and snakes coiling from her head. In Ovid's account (Metamorphoses 4.790–803), Medusa was once a mortal woman of remarkable beauty. After Poseidon violated her in Athena's temple, Athena directed the punishment at Medusa instead of Poseidon. She transformed Medusa's hair into serpents and made her gaze lethal. Notably, the punishment is Ovid's contribution: in Hesiod's earlier telling, Medusa simply lies with Poseidon \"in a soft meadow\" (Theogony 278–279, trans. Evelyn-White) and no transformation follows. Placing this face on sacred architecture was deliberate: it turned the image of divine punishment into a protective ward. Like Arachne and Echo, Medusa is a figure whose humanity was taken by a goddess and replaced with something monstrous and functional. Widowmaker follows the same arc. She is a woman transformed into a precision weapon, with her warmth replaced by mechanical purpose.",
  },
];

export default function MythologyArtifacts() {
  return (
    <FadeInSection>
      <div className="myth-myths-page">
        <section className="hero-section" id="myth-artifacts-header">
          <div className="container">
            <Link to="/mythology" className="back-link">← mythology respawned</Link>
            <h1 className="hero-name myth-page-title">artifacts</h1>
            <p className="hero-role">ancient material culture · transformation and punishment</p>
          </div>
        </section>

        <section className="myth-myths-section">
          <div className="container">
            {artifacts.map((a) => (
              <div className="myth-entry" key={a.name}>
                <div className="myth-entry-header">
                  <span className="myth-character">{a.name}</span>
                </div>
                <p className="myth-source">
                  {a.type} · {a.date} · {a.location}
                </p>
                <p className="myth-source" style={{ marginTop: "-0.6rem" }}>
                  origin: {a.origin}
                </p>
                <img
                  src={a.img}
                  alt={a.imgAlt}
                  className="myth-artifact-img"
                />
                <p className="myth-img-credit">{a.imgCredit}</p>
                <p className="myth-analysis">{a.analysis}</p>
              </div>
            ))}
          </div>
        </section>
      </div>
    </FadeInSection>
  );
}
